export const proServicesKeys = [
  "service1",
  "service2",
  "service3",
  "service4",
  "service5",
  "service6",
  "service7",
  "service8",
] as const;
